import { jsx as a, jsxs as g } from "react/jsx-runtime";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { I as f } from "./icon-button-UFwDzoPr.mjs";
const y = ({ children: e, href: n, className: i, onClick: t }) => n ? /* @__PURE__ */ a("a", { className: i, href: n, onClick: t, children: e }) : /* @__PURE__ */ a("div", { className: i, onClick: t, role: "button", tabIndex: 0, children: e }), x = ({
  button: e,
  badge: n,
  className: i,
  pcType: t = "pcSize",
  theme: o = "ghost"
}) => {
  const c = t === "pcSize";
  return /* @__PURE__ */ g(y, { className: s("relative cursor-pointer", i), href: e.href, onClick: e.onClick, children: [
    /* @__PURE__ */ a(
      f,
      {
        "aria-label": e["aria-label"],
        icon: e.icon,
        size: c ? void 0 : "medium",
        theme: o
      }
    ),
    n
  ] });
}, w = 6, u = ({ item: e, pcType: n = "pcSize", transparent: i }) => {
  const { button: t, text: o } = e, c = o == null ? void 0 : o.substring(0, w), h = n === "pcSize";
  return t.href ? /* @__PURE__ */ a(
    "a",
    {
      className: s("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": h,
        "text-static-white": i
      }),
      href: t.href,
      onClick: t.onClick,
      children: c
    }
  ) : /* @__PURE__ */ a(
    "button",
    {
      className: s("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": h,
        "text-static-white": i
      }),
      onClick: t.onClick,
      onKeyDown: (d) => {
        (d.key === "Enter" || d.key === " ") && t.onClick();
      },
      type: "button",
      children: c
    }
  );
}, N = ({
  title: e = "",
  leftButton: n,
  rightButtons: i,
  children: t,
  pcType: o = "pcSize",
  theme: c,
  className: h,
  ...d
}) => {
  const m = i && i.length > 0, p = o === "pcSize", l = c === "transparent";
  return /* @__PURE__ */ g(
    "div",
    {
      className: s(
        "flex min-h-52 flex-row items-center gap-8 bg-static-white px-6 py-4 align-middle",
        {
          "pc:min-h-76 pc:gap-16 pc:px-10": p,
          "pr-16": !m,
          "bg-transparent": l || c === "ghost"
        },
        h
      ),
      ...d,
      children: [
        /* @__PURE__ */ g("div", { className: s("flex w-full min-w-0 flex-wrap items-center gap-0", { "pc:gap-16": p }), children: [
          /* @__PURE__ */ a("div", { className: s("flex gap-4", { "pc:gap-0": p }), children: /* @__PURE__ */ a(
            x,
            {
              button: n,
              pcType: o,
              theme: l ? "transparent" : "ghost"
            }
          ) }),
          /* @__PURE__ */ a(
            "div",
            {
              className: s("w-full flex-1 overflow-hidden text-left typography-subtitle-18-bold", {
                "pc:typography-headline-24-bold": p,
                "line-clamp-1": !!e && !t,
                "text-static-white": l
              }),
              children: t || e
            }
          )
        ] }),
        !!m && /* @__PURE__ */ a("div", { className: s("flex gap-4", { "pc:gap-0": p }), children: i.map(
          (r, b) => r.type === "Icon" ? /* @__PURE__ */ a(
            x,
            {
              badge: r.badge,
              button: r.button,
              pcType: o,
              theme: l ? "transparent" : "ghost"
            },
            `${r.button["aria-label"]}_${b.toString()}`
          ) : /* @__PURE__ */ a(
            u,
            {
              item: r,
              pcType: o,
              transparent: l
            },
            `${r.text}_${b.toString()}`
          )
        ) })
      ]
    }
  );
};
N.displayName = "NDS.TopNavigation";
export {
  N as T,
  x as a,
  u as b
};
